export default defineNuxtRouteMiddleware((to) => {
    if (to.path === '/' || !to.path.endsWith('/')) return

    const pathWithoutTrailingSlash = to.path.slice(0, -1)
    return navigateTo({ path: pathWithoutTrailingSlash, query: to.query }, { redirectCode: 308 })
})